export default __webpack_public_path__ + "static/media/Right001.1738991a.png";